/**
 * Adherence Repository Interface
 * 복약이행관리 데이터 레이어의 추상화 인터페이스
 *
 * 현재는 모두 mock 응답. 백엔드 endpoint 준비되면 RepositoryImpl만 swap.
 * 명세: docs/BACKEND_API_REQUIREMENTS.md (Step 4)
 */
export class IAdherenceRepository {
  /**
   * 약국 단위 복약이행 KPI
   * @param {string} pharmacyBrn
   * @returns {Promise<BaseResponse<{
   *   managed_count: number,
   *   avg_adherence_percent: number,
   *   notifications_sent: number,
   *   notifications_received: number,
   *   churn_risk_count: number
   * }>>}
   */
  async getKpiSummary(pharmacyBrn) {
    throw new Error('Method must be implemented');
  }

  /**
   * 복약이행 환자 리스트
   * @param {string} pharmacyBrn
   * @param {{ type: 'long'|'short' }} params
   */
  async getPatients(pharmacyBrn, params) {
    throw new Error('Method must be implemented');
  }

  /**
   * 환자 단위 복약이행 상세
   * @param {number|string} userId
   * @param {'long'|'short'|undefined} type 처방 종류 필터 (생략 시 전체)
   */
  async getPatientDetail(userId, type) {
    throw new Error('Method must be implemented');
  }
}
